import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JwtService } from 'src/app/services/jwt.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';

@Component({
    selector: 'app-peme-checkins',
    templateUrl: './peme-checkins.component.html',
    styleUrls: ['./peme-checkins.component.css']
})
export class PemeCheckinsComponent implements OnInit {
    pemeCheckins = {
        client: null as any,
        isWearable: null as number,
        excelFile: null as any,
        commit: false
    };

    uploading = false;
    result: any = null;
    currentStep = 1;

    clients = JSON.parse(sessionStorage.getItem('clients'));
    clientControl = new FormControl();
    filteredClients: Observable<any[]>;

    constructor(
        private api: ApiService,
        private snackbar: MatSnackBar,
        private jwt: JwtService,
        private mixpanel: MixpanelService
    ) { }

    ngOnInit(): void {
        this.mixpanel.track('page_view', {
            page: 'PEME Checkins Upload',
            category: 'Dashboard',
            button: '-'
        });
        this.jwt.check();
        this.filteredClients = this.clientControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filterClients(value || ''))
        );
    }

    private _filterClients(value: string): any[] {
        if (typeof value === 'object' && value !== null) return this.clients;
        const filterValue = value.toLowerCase();
        return this.clients.filter((client: any) =>
            client.dname.toLowerCase().includes(filterValue) ||
            client.id.toString().toLowerCase().includes(filterValue)
        );
    }

    displayClient(client: any): string {
        return client?.dname || '';
    }

    onClientSelected(client: any): void {
        this.pemeCheckins.client = client?.id || null;
    }

    onExcelFileSelected(event: any): void {
        this.pemeCheckins.excelFile = event.target.files[0] ?? null;
    }

    removeExcelFile(): void {
        this.pemeCheckins.excelFile = null;
    }

    private buildFormData(): FormData {
        const formData = new FormData();
        formData.append('client', this.pemeCheckins.client);
        formData.append('isWearable', this.pemeCheckins.isWearable.toString());
        formData.append('excelFile', this.pemeCheckins.excelFile);
        formData.append('commit', this.pemeCheckins.commit ? 'yes' : 'no');
        return formData;
    }

    upload(): void {
        this.mixpanel.track('button_click', {
            page: 'PEME Checkins Upload',
            category: 'Dashboard',
            button: this.pemeCheckins.commit ? 'Upload' : 'Validate'
        });

        this.uploading = true;
        this.result = null;
        this.currentStep = 2;

        this.api.pemeCheckinsUpload(this.buildFormData()).subscribe({
            next: (response) => {
                this.uploading = false;
                console.log('pemeCheckinsUpload response:', response);
                this.result = response?.data || response;
                this.currentStep = 3;

                if (this.result?.success && (!this.result?.errors || this.result.errors.length === 0)) {
                    const msg = this.pemeCheckins.commit
                        ? `Upload complete! ${this.result.insertedRows} rows inserted.`
                        : 'Validation successful!';
                    this.snackbar.open(msg, undefined, { duration: 4000, panelClass: 'success' });
                } else {
                    this.snackbar.open('Validation failed. Please check errors.', undefined, { duration: 4000, panelClass: 'failure' });
                }
            },
            error: (error) => {
                this.uploading = false;
                this.currentStep = 1;
                console.error('Upload failed:', error);
                this.snackbar.open('Upload failed. Please try again.', undefined, { duration: 5000, panelClass: 'failure' });
            }
        });
    }

    promoteToUpload(): void {
        this.pemeCheckins.commit = true;
        this.currentStep = 1;
        this.result = null;
        this.upload();
    }

    resetForm(): void {
        this.pemeCheckins = { client: null, isWearable: null, excelFile: null, commit: false };
        this.clientControl.reset();
        this.result = null;
        this.currentStep = 1;
    }
}
